import OrderFormOption from "@/entities/orderFormOption.entity.js";
import { itaijiFM } from "../plugins.js";
import moment from "moment";

const NO_INPUT = "未記入";
var kanjidate = require("kanjidate");
const orderOption = new OrderFormOption();
const { getPrintType, getColor, getColorCodeBasedOnColorName } = orderOption;

const ITAIJI_LIST = [
  {
    name: "位表記",
    key: "underCharacters",
  },
  {
    name: "俗名表記",
    key: "secularNamePrefix",
  },
  {
    name: "没表記",
    key: "diedCharacter",
  },
  {
    name: "施主",
    key: "hostName",
  },
];

const COLUMN_ITAIJI_LIST = [
  {
    name: "戒名",
    key: "buddhistName",
  },
  {
    name: "位表記",
    key: "underCharacters",
  },
  {
    name: "俗名",
    key: "secularName",
  },
  // {
  //   name: "俗名(俗名表記)",
  //   key: "secularNamePrefix"
  // },
  {
    name: "没年月日",
    key: "dateOfDeath",
  },
  {
    name: "没年月日(年)",
    key: "dateOfDeathYear",
  },
  {
    name: "没年月日(月)",
    key: "dateOfDeathMonth",
  },
  {
    name: "没年月日(日)",
    key: "dateOfDeathDay",
  },
  {
    name: "享年表記",
    key: "ageAtDeathPrefix",
  },
  {
    name: "没年齢",
    key: "ageAtDeath",
  },
  {
    name: "年齢単位",
    key: "ageUnitCharacter",
  },
];

function getNeededCharacter (isNeeded) {
  let result = false;
  if (Array.isArray(isNeeded)) {
    // eslint-disable-next-line
    result = isNeeded.length > 0 ? true : false;
  } else {
    result = !!isNeeded;
  }
  return result ? "入れる" : "入れない";
}

/**
 * 戒名の1文字
 *
 * @export
 * @class BuddhistNameCharacter
 */
export class BuddhistNameCharacter {
  variantCharacterId = null;
  character = "";
  imageUrl = null;
  points = [];
  constructor (data) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }
}

/**
 * 戒名
 *
 * @export
 * @class BuddhistNameCharacter
 */
export class BuddhistName {
  _data = [];

  constructor (data = {}) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }

  toJson () {
    return this._data;
  }

  get text () {
    return this._data.reduce((cur, next) => cur + next.character, "");
  }

  set (data = {}) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }

  static fromText (text) {
    const _data = text.split("").map(character => {
      return new BuddhistNameCharacter({ character });
    });
    return new BuddhistName({ _data });
  }

  static toObject (data) {
    if (Array.isArray(data)) {
      return new BuddhistName({ _data: data });
    }
    if (data instanceof BuddhistName) {
      return data;
    }
    if (typeof data === "object") {
      return new BuddhistName({ _data: data._data });
    }
    if (typeof data === "string") {
      return BuddhistName.fromText(data);
    }
    return new BuddhistName();
  }
}

/**
 * 俗名の1文字
 *
 * @export
 * @class BuddhistNameCharacter
 */
export class SecularNameCharacter {
  variantCharacterId = null;
  character = "";
  imageUrl = null;
  points = [];
  constructor (data) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }
}

/**
 * 俗名
 *
 * @export
 * @class SecularNameCharacter
 */
export class SecularName {
  _data = [];

  constructor (data = {}) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }

  toJson () {
    return this._data;
  }

  get text () {
    return this._data.reduce((cur, next) => cur + next.character, "");
  }

  set (data = {}) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }

  static fromText (text) {
    const _data = text.split("").map(character => {
      return new SecularNameCharacter({ character });
    });
    return new SecularName({ _data });
  }

  static toObject (data) {
    if (Array.isArray(data)) {
      return new SecularName({ _data: data });
    }
    if (data instanceof SecularName) {
      return data;
    }
    if (typeof data === "object") {
      return new SecularName({ _data: data._data });
    }
    if (typeof data === "string") {
      return SecularName.fromText(data);
    }
    return new SecularName();
  }
}

export default class Order {
  constructor (data = {}) {
    Object.keys(data).map(key => {
      if (key === "detail" && data[key].columns) {
        // data[key].columns.map(el => {
        //   // el.buddhistName = el.buddhistName;
        //   // el.secularName = new SecularName.toObject(el.secularName);
        // });
      }
      this[key] = data[key];
    });
  }
  get input () {
    return null;
  }

  /**
   * For Information Table
   */
  get clientGroupInformation () {
    const { clientGroup, deliveryDestination } = this;
    return [
      ["店舗", clientGroup && clientGroup.id ? clientGroup.name : "未選択"],
      [
        "支店",
        deliveryDestination && deliveryDestination.id
          ? deliveryDestination.name
          : "未選択",
      ],
    ];
  }
  get customerInformation () {
    const {
      name,
      zipcode,
      address,
      tel,
      sect,
      familyTemple,
      customerNumber,
      note,
    } = this.customer;
    const {
      fortyNinthMemorialServiceDate,
      contractDate,
      deliveryDate,
      attachments,
    } = this.detail;
    return [
      ["お名前", name || NO_INPUT],
      ["郵便番号", zipcode || NO_INPUT],
      ["住所", address || NO_INPUT],
      ["電話番号", tel || NO_INPUT],
      ["宗派", sect || NO_INPUT],
      ["菩提寺", familyTemple || NO_INPUT],
      [
        "四十九日法要日",
        moment(fortyNinthMemorialServiceDate).isValid()
          ? moment(fortyNinthMemorialServiceDate).format("YYYY年M月D日") ||
            NO_INPUT
          : "指定なし",
      ],
      [
        "ご契約日",
        moment(contractDate).isValid()
          ? moment(contractDate).format("YYYY年M月D日") || NO_INPUT
          : "指定なし",
      ],
      [
        "納品日",
        moment(deliveryDate).isValid()
          ? moment(deliveryDate).format("YYYY年M月D日") || NO_INPUT
          : "指定なし",
      ],
      ["顧客番号", customerNumber || NO_INPUT],
      ["備考", note || NO_INPUT],
      [
        "ファイル",
        attachments.map(attachment => ({ type: "attachment", src: attachment })),
      ],
    ];
  }
  get customFieldInformation () {
    if (!this.customFields) {
      return [];
    }

    const customFields = [];

    this.customFields.forEach(customField => {
      const name = customField.name;
      const value = customField.type === "DATE" ? getExpectedShippingDate(customField.value) : customField.value;

      customFields.push([
        name,
        value || NO_INPUT,
      ]);
    });

    return customFields;
  }
  get productInformation () {
    const {
      product,
      productVariation,
      azukariProductName,
      azukariProductSize,
      quantity,
    } = this.detail;

    if (
      !product ||
      !productVariation
    ) {
      return [];
    }

    // TODO 寸法(productDimensions)については現状注文詳細での表示は必要ないためコメントアウトしておく
    // const {
    //   height,
    //   width,
    //   depth,
    // } = productVariation;
    //
    // 位牌の寸法表記（テキスト）を取得
    // const getDimensionsTextFn = () => {
    //   // 位牌サイズの入力がある場合
    //   if (height && width && depth) {
    //     return `H${height}×W${width}×D${depth}`;
    //   }
    //
    //   return "--";
    // };

    const isAzukariIhaiProduct = product.category.id === "99000";
    const productName = isAzukariIhaiProduct
      ? azukariProductName
      : product.name;
    const productVariationSize = isAzukariIhaiProduct
      ? azukariProductSize || productVariation.size
      : productVariation.size;
    // const productDimensions = getDimensionsTextFn();

    return [
      ["商品名", productName],
      ["本数", `${quantity}本`],
      ["種類", productVariationSize],
      // ["寸法(cm)", productDimensions],
    ];
  }
  get orderTypeInformation () {
    const { detail } = this;
    const { orderType, layout } = detail;
    if (!orderType || !layout) {
      return null;
    }

    const orderTypeNameCount = typeof orderType.nameCount === "number" ? orderType.nameCount.toString() : orderType.nameCount;

    return [
      ["位牌種類", orderType.type],
      ["霊数", orderTypeNameCount],
      ["レイアウト", layout.name],
    ];
  }
  get typographyInformation () {
    const { detail } = this;
    const { typography } = detail;
    if (!typography) {
      return null;
    }
    return [
      ["彫り・書き", getPrintType(typography.printType)],
      ["書体", typography.font === "標準書体" ? "楷書体" : typography.font],
      ["文字色 - おもて", getColor(typography.textColorFront)],
      ["文字色 - うら", getColor(typography.textColorBack)],
    ];
  }
  get detailInformation () {
    const { detail } = this;
    const result = [];

    // 位牌のタイプを調べる
    const {
      orderType,
      layout,
    } = detail;
    const tabletType = orderType ? orderType.type : null;
    if (!tabletType) {
      // 位牌がなければ、何も表示しない
      return [];
    }
    // 位牌が通常である場合-1以外を返すフラグ
    const flg = tabletType.indexOf("通常");
    result.push([
      "梵字・家紋",
      getSanskritCharacterOrFamilyEmblemCharacter(
        detail.sanskritCharacterOrFamilyEmblem
      ),
    ]);
    if (detail.sanskritCharacterOrFamilyEmblem === "SANSKRIT_CHARACTER") {
      result.push([
        "梵字",
        `${
          detail.sanskritCharacter || detail.customSanskritCharacterUrl
            ? "入れる"
            : "入れない"
        } ${
          detail.sanskritCharacter && detail.sanskritCharacter.sect
            ? detail.sanskritCharacter.sect
            : ""
        }`,
      ]);
    } else if (detail.sanskritCharacterOrFamilyEmblem === "FAMILY_EMBLEM") {
      result.push([
        "家紋",
        `${
          detail.familyEmblem.name || detail.customFamilyEmblemUrl
            ? "入れる　" + detail.familyEmblem.name
            : "入れない"
        }`,
      ]);
    }
    // 裏梵字カスタム画像の場合
    if (detail.customSanskritCharacterBackUrl) {
      result.push(["裏梵字", `${getNeededCharacter(true)} ユーザー選択画像`]);
      // 既存の裏梵字を選択の場合
    } else {
      const isSanskritCharacterBackNeeded = !(
        detail.isSanskritCharacterBackNeeded === false ||
        detail.sanskritCharacterBack == null ||
        detail.sanskritCharacterBack.id === 0
      );
      result.push([
        "裏梵字",
        `${
          isSanskritCharacterBackNeeded
            ? getNeededCharacter(true)
            : getNeededCharacter(false)
        } ${
          isSanskritCharacterBackNeeded ? detail.sanskritCharacterBack.sect : ""
        }`,
      ]);
    }
    if (flg !== -1) {
      result.push(
        ...[
          [
            "俗名の表記",
            detail.secularNamePrefix === null
              ? "未選択"
              : getNeededCharacter(detail.secularNamePrefix),
          ],
          [
            "没表記",
            `${getNeededCharacter(detail.isDiedCharacterNeeded)} ${
              detail.isDiedCharacterNeeded && detail.diedCharacter
                ? itaijiFM.getText(detail.diedCharacter)
                : ""
            }`,
          ],
        ]
      );
    } else {
      result.push(
        ...[
          [
            "没表記",
            `${getNeededCharacter(detail.isDiedCharacterNeeded)} ${
              detail.isDiedCharacterNeeded && detail.diedCharacter
                ? itaijiFM.getText(detail.diedCharacter)
                : ""
            }`,
          ],
        ]
      );
    }

    // 施主の入力があるレイアウトタイプの場合
    if (layout && layout.id === "m1-b") {
      const _hostName = itaijiFM.getText(detail.hostName);
      const hostName = _hostName !== "" ? _hostName : "未入力";
      result.push(["施主", hostName]);
    }

    return result;
  }
  get columnsInformation () {
    const { detail } = this;
    // 位牌のタイプを調べる
    const { orderType } = detail;
    const tabletType = orderType ? orderType.type : null;
    if (!tabletType) {
      // 位牌がなければ、何も表示しない
      return [];
    }
    // 位牌が通常である場合-1以外を返すフラグ
    const flg = tabletType.indexOf("通常");

    return this.detail.columns.map(column => {
      const {
        buddhistName,
        secularName,
        dateOfDeath,
        ageAtDeathPrefix,
        ageAtDeath,
        ageUnitCharacter,
      } = column;
      const {
        underCharacters,
      } = detail;

      if (flg !== -1) {
        return [
          ["戒名", itaijiFM.getText(buddhistName)],
          [
            "位表記",
            itaijiFM.getText(underCharacters) || getNeededCharacter(false),
          ],
          ["俗名", itaijiFM.getText(secularName)],

          ["没年月日", itaijiFM.getText(dateOfDeath)],
          ["享年表記", itaijiFM.getText(ageAtDeathPrefix)],
          ["没年齢", itaijiFM.getText(ageAtDeath)],
          ["年齢単位", itaijiFM.getText(ageUnitCharacter)],
        ];
      } else {
        return [
          ["俗名", itaijiFM.getText(secularName)],
          ["没年月日", itaijiFM.getText(dateOfDeath)],
          ["享年表記", itaijiFM.getText(ageAtDeathPrefix)],
          ["没年齢", itaijiFM.getText(ageAtDeath)],
          ["年齢単位", itaijiFM.getText(ageUnitCharacter)],
        ];
      }
    });
  }
  get categoryInformation () {
    try {
      var categoryName = "";
      if (this.detail.product) {
        categoryName = this.detail.product.category.name;
      }
      return [["カテゴリ", categoryName]];
    } catch (err) {
      return null;
    }
  }
  get otherInformation () {
    const { expectedShippingDate } = this.detail;
    return [["希望納期", getExpectedShippingDate(expectedShippingDate)]];
  }
  get itaijiPointsInformation () {
    const { columns } = this.detail;
    // 異体字が設定可能な項目
    const list = ITAIJI_LIST;
    // 異体字が設定可能な項目 for column
    const columnList = COLUMN_ITAIJI_LIST;
    // 異体字が設定可能な項目 と 異体字が設定可能な項目 for columnをマージして注意文字を表示する
    const res = [
      ...list
        .map(o => {
          return [
            [[o.name, ""]],
            this.detail[o.key] &&
            this.detail[o.key].map(p => [
              p.character,
              p.points.map(q => ({ src: q })),
              { type: "comment", value: p.comment },
            ]),
          ];
        })
        .flat()
        .flat()
        .filter(o => o),
      ...columns
        .reduce((acc, cur) => {
          return [
            ...acc,
            ...columnList
              .map(o => {
                try {
                  return [
                    [[o.name, ""]],
                    cur[o.key].map(p => [
                      p.character,
                      p.points.map(q => ({ src: q })),
                      { type: "comment", value: p.comment },
                    ]),
                  ];
                } catch (err) {
                  return null;
                }
              })
              .filter(o => o)
              .flat(),
          ];
        }, [])
        .flat()
        .filter(o => o),
    ];
    return res;
  }

  get itaijiPointsInformationForPrint () {
    const { columns } = this.detail;

    // 異体字が設定可能な項目
    const itaijiList = ITAIJI_LIST;

    // columns 内の異体字が設定可能な項目
    // 没年月日の重複があるようなので dateOfDeath は除いておく
    const columnItaijiList = COLUMN_ITAIJI_LIST.filter(item => item.key !== "dateOfDeath");

    // 異体字が設定可能な項目の注意文字のリスト生成
    const listItems = itaijiList.flatMap(item => {
      const target = this.detail[item.key];
      const characters = target && target.map(obj => {
        return {
          label: item.name,
          character: obj.character,
          points: obj.points.map(point => ({ src: point })),
          comment: obj.comment,
        };
      });

      return characters || [];
    });

    // columns 内の異体字が設定可能な項目の注意文字のリスト生成
    const columnListItems = columns.flatMap(column => {
      const columnListItem = columnItaijiList.flatMap(item => {
        const target = column[item.key];
        const characters = target && target.map(obj => {
          return {
            label: item.name,
            character: obj.character,
            points: obj.points.map(point => ({ src: point })),
            comment: obj.comment,
          };
        });

        return characters;
      });

      return columnListItem;
    });

    return [
      ...listItems,
      ...columnListItems,
    ].filter(item => item.points.length);
  }

  get itaijiPoints () {
    if (!this.detail.columns) {
      return [];
    }
    return this.detail.columns.reduce((acc, cur) => {
      return [
        ...acc,
        ...getPoints(cur.buddhistName),
        ...getPoints(cur.secularName),
      ];
    }, []);
  }

  get statusAndAuthorInformation () {
    const { status, client } = this;
    const { expectedShippingDate } = this.detail;
    const splitDate = expectedShippingDate && expectedShippingDate.split("-");
    const shippingDate =
      splitDate &&
      kanjidate.format(
        kanjidate.f2,
        new Date(splitDate[0], splitDate[1] - 1, splitDate[2])
      );
    return [
      ["ステータス", status.name || ""],
      ["作成者", client ? client.name : "[削除されたユーザー]"],
      ["希望納期", shippingDate || ""],
    ];
  }
  isEditable (operatorId) {
    return this.isEditableStatus && operatorId === this.order.staff.id;
  }
  isEditableAuthority (orderClient, currentUser) {
    // 発注権限有ユーザ(CLIENT_USER)の場合は、すべての注文情報を編集可とする
    if (
      currentUser &&
      currentUser.role === "CLIENT_USER"
    ) {
      return true;
    }

    // 利用者権限ユーザ(CLIENT_CONTRIBUTOR)の場合は、自身の注文のみ編集可とする
    if (
      currentUser &&
      currentUser.role === "CLIENT_CONTRIBUTOR"
    ) {
      return orderClient ? orderClient.id === currentUser.sub : false;
    }

    return false;
  }
  get isEditableStatus () {
    return this.isUnorderEditStatus;
  }
  get isDeletable () {
    return this.isUnorderDeleteStatus;
  }
  get isSubmitable () {
    return this.isUnorderSubmitStatus;
  }
  get isUnorderDeleteStatus () {
    const { status } = this;
    return !!["DRAFT", "ORDER_REQUEST"].find(el => el === status.code);
  }
  get isUnorderEditStatus () {
    const { status } = this;
    return !!["DRAFT", "ORDER_REQUEST", "PROCESSING"].find(
      el => el === status.code
    );
  }
  get isUnorderSubmitStatus () {
    const { status } = this;
    return !!["DRAFT", "ORDER_REQUEST"].find(el => el === status.code);
  }
  get isCancellable () {
    const { status } = this;
    return !!["PROCESSING", "PROCESSING_CREATING_LAYOUT", "REVISING_LAYOUT"].find(el => el === status.code);
  }
  get isShipped () {
    const { status } = this;
    return !![
      "PROCESSING",
      "PROCESSING_CREATING_LAYOUT",
      "REVISING_LAYOUT",
      "CONFIRMED",
      "SHIPPED",
      "CANCEL_REQUEST",
    ].find(el => el === status.code);
  }
  get buttonGroup () {
    const { status } = this;
    return !!["PROCESSING", "PROCESSING_CREATING_LAYOUT", "REVISING_LAYOUT", "CONFIRMED", "SHIPPED"].find(
      el => el === status.code
    );
  }
  get fontColors () {
    const { detail } = this;
    const { typography } = detail;

    if (!typography) {
      return [{}, {}];
    }
    const { textColorBack, textColorFront } = typography;
    return [
      createColorObject(textColorBack),
      createColorObject(textColorFront),
    ];
  }
  get orderCreatePayload () {
    const {
      status,
      parentOrderId,
      clientGroup,
      deliveryDestination,
      customer,
      customFields,
      detail,
    } = this;
    const {
      product,
      productVariation,
      azukariProductName,
      azukariProductSize,
      quantity,
      orderType,
      layout,
      typography,
      underCharacters,
      underCharactersPlacement,
      secularNamePrefixPlacement,
      ageAtDeathPrefixPlacement,
      sanskritCharacterOrFamilyEmblem,
      sanskritCharacter,
      familyEmblem,
      sanskritCharacterBack,
      isSanskritCharacterBackNeeded,
      customSanskritCharacterUrl,
      customSanskritCharacterBackUrl,
      customFamilyEmblemUrl,
      secularNamePrefix,
      isDiedCharacterNeeded,
      isOldCharacterForDateOfDeathNeeded,
      diedCharacter,
      ageAtDeathPrefix,
      ageUnitCharacter,
      columns,
      fortyNinthMemorialServiceDate,
      contractDate,
      deliveryDate,
      isNeededLayoutReply,
      expectedShippingDate,
      signature,
      attachments,
      hostName,
    } = detail;
    const columnsPayload = columns.map(el => {
      const {
        secularNameSuffix,
        dateOfDeathYear,
        dateOfDeathMonth,
        dateOfDeathDay,
        ...rest
      } = el;
      return {
        ...rest,
        underCharacters: getItaijiPayload(el.underCharacters),
        ageAtDeathPrefix: getItaijiPayload(el.ageAtDeathPrefix),
        ageAtDeath: getItaijiPayload(el.ageAtDeath),
        ageUnitCharacter: getItaijiPayload(el.ageUnitCharacter),
        buddhistName: getItaijiPayload(el.buddhistName),
        secularName: getItaijiPayload(el.secularName),
        secularNameSuffixId: secularNameSuffix ? secularNameSuffix.id : "",
        dateOfDeath: getItaijiPayload([
          ...dateOfDeathYear,
          ...dateOfDeathMonth,
          ...dateOfDeathDay,
        ]),
      };
    });

    const childOrdersPayload = Array.isArray(this.childOrders)
      ? this.childOrders.map(childOrder => {
        const childOrderEntity = childOrder instanceof Order
          ? childOrder
          : Order.fromJson(childOrder);
        const childPayload = childOrderEntity.orderCreatePayload.order;
        return {
          id: childOrderEntity.id || undefined,
          ...childPayload,
          parentOrderId: this.id || parentOrderId || childPayload.parentOrderId,
        };
      })
      : [];

    return {
      order: {
        status,
        clientGroupId: (clientGroup && clientGroup.id) || "",
        deliveryDestinationId:
          (deliveryDestination && deliveryDestination.id) || "",
        parentOrderId,
        customer,
        customFields,
        detail: {
          productId: product ? product.id : null,
          productVariationId: productVariation ? productVariation.id : null,
          azukariProductName,
          azukariProductSize,
          quantity,
          orderType,
          layoutId: layout ? layout.id : null,
          typography,
          // 位中心時用
          underCharacters: getItaijiPayload(underCharacters),
          // 配置ルール追加
          underCharactersPlacement: underCharactersPlacement || null,
          secularNamePrefixPlacement,
          ageAtDeathPrefixPlacement,
          sanskritCharacterOrFamilyEmblem,
          // "梵字"
          sanskritCharacterId: sanskritCharacter ? sanskritCharacter.id : null,
          // "家紋"
          familyEmblemId: familyEmblem ? familyEmblem.id : null,
          // ユーザー選択梵字
          customSanskritCharacterUrl:
            sanskritCharacterOrFamilyEmblem === "SANSKRIT_CHARACTER" &&
            sanskritCharacter &&
            !sanskritCharacter.Id
              ? customSanskritCharacterUrl
              : null,
          // ユーザー選択裏梵字
          customSanskritCharacterBackUrl,
          // ユーザー選択家紋
          customFamilyEmblemUrl: customFamilyEmblemUrl,
          // # 俗名関係
          // "裏梵字"
          sanskritCharacterBackId: isSanskritCharacterBackNeeded
            ? sanskritCharacterBack
              ? sanskritCharacterBack.id
              : null
            : null,
          // "俗名表記"
          secularNamePrefix: getItaijiPayload(secularNamePrefix),
          // # 年月日関係
          // "没表記がいるかどうか"
          isDiedCharacterNeeded,
          // "没表記の文字"
          diedCharacter: getItaijiPayload(diedCharacter),
          //  "没表記"
          isOldCharacterForDateOfDeathNeeded,

          // # 年齢関係
          // "享年表記"
          ageAtDeathPrefix: getItaijiPayload(ageAtDeathPrefix),
          // "年齢単位"
          ageUnitCharacter: getItaijiPayload(ageUnitCharacter),

          // # 詳細設定
          // "各名の設定"
          columns: columnsPayload,
          fortyNinthMemorialServiceDate: moment(
            fortyNinthMemorialServiceDate
          ).isValid()
            ? moment(fortyNinthMemorialServiceDate).format("YYYY-MM-DD")
            : "",
          // 契約日
          contractDate: moment(contractDate).isValid()
            ? moment(contractDate).format("YYYY-MM-DD")
            : "",
          // 納品日
          deliveryDate: moment(deliveryDate).isValid()
            ? moment(deliveryDate).format("YYYY-MM-DD")
            : "",
          // "レイアウト返信を希望しますか"
          isNeededLayoutReply,
          // "希望する配送日"
          expectedShippingDate: moment(expectedShippingDate).isValid()
            ? moment(expectedShippingDate).format("YYYY-MM-DD")
            : "",
          // "実際に予想される配送日"
          fixedShippingDate: "",
          // お客様のサイン
          signature: signature,
          // // 添付画像URLのリスト
          attachments: attachments,
          // 施主
          hostName: getItaijiPayload(hostName) || [],
        },
        childOrders: childOrdersPayload,
      },
    };
  }
  updateStatus (status) {
    this.status = status;
  }
  static fromJson (json) {
    return new Order(json);
  }
}

function createColorObject (color) {
  try {
    const colorCode = getColorCodeBasedOnColorName(color);
    const targetColors = orderOption.colorsForFront.filter(
      el => el.value === color
    );
    if (!targetColors.length) {
      return {};
    }
    const name = targetColors[0].label;
    return {
      name,
      colorCode,
    };
  } catch (err) {
    console.log(err);
    return {};
  }
}

function getExpectedShippingDate (shipDate) {
  var date = new Date(shipDate);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var dt = date.getDate();
  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }
  return shipDate ? year + "/" + month + "/" + dt : "未選択";
}

function getSanskritCharacterOrFamilyEmblemCharacter (value) {
  switch (value) {
    case "NO_NEED":
      return "入れない";
    case "SANSKRIT_CHARACTER":
      return "梵字";
    case "FAMILY_EMBLEM":
      return "家紋";
  }
  return "未選択";
}

function getPoints (itaiji) {
  if (!itaiji || itaiji.length === 0) {
    return [];
  }
  return itaiji.reduce((acc, cur) => {
    return [...acc, ...cur.points];
  }, []);
}

function getItaijiPayload (itaiji) {
  if (!itaiji || itaiji.length === 0) {
    return [];
  }
  return itaiji.map(o => ({
    variantCharacterId: o.variantCharacterId,
    character: o.character,
    points: o.points,
    comment: o.comment,
  }));
}
